module.exports = __webpack_public_path__ + "static/media/vegitables_51.710af290.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_51.csv
// module id = 637
// module chunks = 0